import getUrl from 'lib/url'
import { ISelectedOptions } from './reducer'
import fetch from 'lib/decorated-fetch'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { getClientIP } from '../../../../server/common/utils'
import { logger } from 'lib/slardar-utils'
import asgwFontLoader from '@byted/asgw-font-loader'
interface IGetSeriesParams {
  brand_id?: string
  sh_city_name?: string
}
export interface IShSeriesData {
  series_id: number
  series_name: string
  image_url: string
}

export const getSeries = async (params: IGetSeriesParams, req?: any) => {
  try {
    const url = getUrl(
      `/motor/pc/sh/sh_series_list?${serializeObject(params)}`,
      'motor.pc_sh.api'
    )
    const res = await fetch(url, { req })
    if (res?.status === 0 && res.data) {
      return res.data
    }
  } catch (err) {
    logger.error(
      `[/motor/pc/sh/sh_series_list onError] error message: ${
        (err as any)?.message
      }, params:${serializeObject(params)}`
    )
  }
}

export interface ICardTag {
  text?: string // 文案
  logo?: string // 图标
  text_color?: string // 文字颜色
  background_color?: string // 背景颜色
}
export interface ISearchSHSkuInfo {
  sku_id?: number // 车源ID
  shop_id?: string // 店铺ID
  series_id?: number // 车系ID
  series_name?: string // 车系名称
  brand_id?: number // 品牌ID
  brand_name?: string // 品牌名称
  car_id?: number // 车款ID
  car_name?: string // 车款名称
  car_year?: number // 年款
  status?: number // 上下架状态
  car_source_city_name?: string // 车源所在地
  brand_source_city_name?: string // 品牌所在地
  spu_id?: number // spu id
  platform_type?: number // 车源平台(0-自营 1-58)
  group_id?: number // 关联gid
  group_id_str?: string // 关联gid str
  image?: string // 图片
  sh_price: string // 二手车价格
  official_price?: string // 官方指导价
  tags?: ICardTag[] // 标签列表
  related_video_thumb?: string // 视频缩略图（没有缩略图显示图片）
  car_age?: string // 车龄
  car_mileage?: string // 里程
  title?: string // 卡片标题
  sub_title?: string // 卡片子标题
  is_video?: boolean // 是否有视频
  car_source_type?: string
  authentication_method?: string
  transfer_cnt?: number
}
export interface ISearchSHSkuListData {
  search_sh_sku_info_list?: ISearchSHSkuInfo[]
  has_more?: boolean
  total?: number
}
export interface SearchSHSkuListResp {
  prompts: string
  status: number
  message: string
  data: ISearchSHSkuListData
}

function buildQuery(query: any) {
  delete query.dcar_score
  return Object.keys(query)?.reduce((prev: string, key: string) => {
    let currentKey = key
    let val = query[key]
    if (!val) return prev
    if (typeof query[key] === 'object') {
      if (key === 'tab') {
        val = '1'
        currentKey = query[key][0].key
      } else {
        val = query[key][0].param
      }
    }
    return `${prev}&${currentKey}=${val}`
  }, '')
}
export const getCars = async (query: any, limit: number, req?: any) => {
  query.limit = limit
  const queryString = buildQuery(query)
  try {
    let ip = ''
    if (req) {
      ip = getClientIP(req)
    }
    const res = await fetch(
      getUrl('/motor/pc/sh/sh_sku_list', 'motor.pc_sh.api'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-forwarded-for': ip,
        },
        body: queryString,
        req,
        rawRes: true,
      }
    )
    const json = await res.json()
    const fontStyleString = asgwFontLoader
      ?.parseHeaders(res?.headers)
      ?.toStyleString()
    if (json?.status === 0 && json.data) {
      return { ...json.data, fontStyleString }
    }
    return {}
  } catch (err) {
    logger.error(
      `[/motor/pc/sh/sh_sku_list onError]error message: ${
        (err as any)?.message
      }, params:${queryString} `
    )
    return {}
  }
}

export const getParamsFromState = (state: ISelectedOptions) => {
  return Object.entries(state)
    .filter(([, value]) => !!value && value.length > 0)
    .map(([key, value]) => {
      if (!value) {
        return ''
      }
      return `${key}=${value?.map((item) => item.param).join(',')} `
    })
    .join('&')
}

export const fetchSeriesInfo = (seriesId: string, req?: any) => {
  return fetch(
    getUrl(
      `/motor/pc/car/series/get_series_info?series_id=${seriesId}`,
      'motor.pc_car.api'
    ),
    { req }
  ).then((data) => data)
}
